import { createRequestAction } from '../../Helpers/Action.helpers';
import { REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { PROVIDER_SERVICE_URLS } from '../../Constants/Urls.constants';
import { AvailableProviders } from '../../Models/DTO/AvailableProviders.model';
import { routeReplacer } from '../../Helpers/String.helper';
import { ProviderPatch } from '~/Models/DTO/Provider.model';

export const requestProviderById = (id: string) =>
  createRequestAction<AvailableProviders[]>({
    name: REQUEST_ACTIONS.GET_PROVIDER,
    url: routeReplacer(PROVIDER_SERVICE_URLS.PROVIDER_DETAIL, { id }),
    method: 'GET',
  });

export const requestProviderTrainerList = (id: string) =>
  createRequestAction({
    url: routeReplacer(PROVIDER_SERVICE_URLS.TRAINER_LIST, { id }),
    name: REQUEST_ACTIONS.TRAINER_LIST,
    method: 'GET',
  });

export const requestUpdateProvider = (id: string, data: ProviderPatch) =>
  createRequestAction({
    name: REQUEST_ACTIONS.UPDATE_PROVIDER,
    url: routeReplacer(PROVIDER_SERVICE_URLS.PROVIDER_DETAIL_UPDATE, { id }),
    data,
    method: 'PATCH',
  });
